import React from 'react';
import PropTypes from 'prop-types';

/**
 *
 * A simple wrapper to apply `List` styles to an `Icon`.
 *
 * Usage:
 *
 * ```jsx
 * import { ListItemIcon } from '@one-thd/sui-atomic-components';
 * ```
 */
const ListItemIcon = React.forwardRef((props, ref) => {

  const {
    component: ListItemIconRoot = 'div',
    ...other
  } = props;

  return (
    <ListItemIconRoot
      className="sui-shrink-0 sui-inline-flex sui-min-w-14 sui-mr-2"
      ref={ref}
      {...other}
    />
  );
});

ListItemIcon.displayName = 'ListItemIcon';

ListItemIcon.propTypes = {
  /**
   * The content of the component, normally a @one-thd/sui-icons SVG icon element.
   */
  component: PropTypes.elementType,
};

export { ListItemIcon };
